import { render } from "./ChiffreAffaire.vue?vue&type=template&id=6745b44a&scoped=true"
import script from "./ChiffreAffaire.vue?vue&type=script&lang=js"
export * from "./ChiffreAffaire.vue?vue&type=script&lang=js"

import "./ChiffreAffaire.vue?vue&type=style&index=0&id=6745b44a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6745b44a"]])

export default __exports__